/**
 * Study duration for timeline: sessionStorage helpers.
 * Used when navigating from study card to study context so the timeline grid shows the correct day count.
 * Cleared when the user returns to the studies list.
 */

const STORAGE_KEY = 'studyDurationForTimeline'

/**
 * @returns {{ study_duration: number } | null}
 */
export const getStudyDurationForTimeline = () => {
  try {
    if (typeof sessionStorage === 'undefined') return null
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed && typeof parsed.study_duration === 'number' && Number.isFinite(parsed.study_duration)) {
      return parsed
    }
  } catch (e) {}
  return null
}

/**
 * @param {{ study_duration: number } | null} payload
 */
export const setStudyDurationForTimeline = payload => {
  try {
    if (typeof sessionStorage === 'undefined') return
    if (payload != null && payload.study_duration != null) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
    } else {
      sessionStorage.removeItem(STORAGE_KEY)
    }
  } catch (e) {}
}

export const removeStudyDurationForTimeline = () => {
  try {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem(STORAGE_KEY)
    }
  } catch (e) {}
}

/**
 * Derive study duration in days from currentStudy (fallback when session is empty).
 * Uses study_duration (top-level) or cycles[0].studyDuration * durationType multiplier.
 * @param {{ study_duration?: number, cycles?: Array<{ studyDuration: number, durationType?: string }>, config?: { cycles?: Array } } | null} study
 * @returns {{ study_duration: number } | null}
 */
export const getStudyDurationFromStudy = study => {
  if (!study) return null
  if (typeof study.study_duration === 'number' && Number.isFinite(study.study_duration)) {
    return { study_duration: study.study_duration }
  }
  const cycles = study.cycles || study.config?.cycles
  if (Array.isArray(cycles) && cycles.length > 0) {
    const c = cycles[0]
    const dur = c?.studyDuration
    const type = c?.durationType
    if (dur != null && typeof dur === 'number' && Number.isFinite(dur)) {
      const days = type === 'weeks' ? dur * 7 : dur
      if (days >= 1) return { study_duration: Math.floor(days) }
    }
  }
  return null
}
